export const printFileFromBuffer = (buffer: Buffer, mime?: string): void => {
  const blob = new Blob([buffer], { type: mime !== undefined ? mime : 'application/octet-stream' })
  const url = URL.createObjectURL(blob)

  const existedIframe = document.querySelector('iframe')
  const iframe = (existedIframe != null)
    ? existedIframe
    : document.createElement('iframe')

  document.body.appendChild(iframe)
  iframe.style.display = 'none'
  iframe.src = url
  iframe.onload = function () {
    setTimeout(function () {
      iframe.focus()
      iframe.contentWindow?.print()
    }, 1)
  }
}

export const getFileFromBuffer = (
  buffer: Buffer,
  mime?: string,
  downloadFileName?: string
): void => {
  const blob = new Blob([buffer], { type: mime !== undefined ? mime : 'application/octet-stream' })
  getFileFromBlob(blob, downloadFileName)
}

const getFileFromBlob = (blob: Blob, downloadFileName?: string): void => {
  const url = window.URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.target = '_blank'
  if (downloadFileName !== undefined) {
    anchor.download = downloadFileName
  }
  anchor.click()
}
